<template>
  <a-card :bordered="false" :loading="table.loading">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <a-form-model
            layout="inline"
            label-position="top"
          :model="searchForm.data">
          <a-form-model-item :label="$t('NICKNAME') || '昵称' ">
            <a-input v-model="searchForm.data.nickname" allowClear/>
          </a-form-model-item>
          <a-form-model-item :label="$t('TELEPHONE') || '手机' ">
            <a-input v-model="searchForm.data.telephone" allowClear/>
          </a-form-model-item>
          <a-form-model-item :label="$t('GRADE') || '会员等级'">
            <dict-select
            style="width: 160px"
            v-model="searchForm.data.grade"
            dict-code="USER_GRADE"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('OPERATION') || '操作'">
            <a-space>
            <a-button
              type="primary"
              plain
              icon="el-icon-search"
               @click="searchUser">{{ $t('SEARCH') || '查询' }}
            </a-button>
            <a-button
            type="primary"
            plain
            @click="exportUser"
            >{{ $t('EXPORT') || '' }}</a-button>
            </a-space>
          </a-form-model-item>
        </a-form-model>
      </div>
      <a-table
        :scroll="{ y: 'calc(100vh - 405px)' }"
        :data-source="table.data"
        :pagination="table.pagination"
        :loading="table.loading"
        row-key="id"
        @change="handleTableChange"
        style="width: 100%">
        <a-table-column
          data-index="nickname"
          :title="$t('NICKNAME') || '昵称'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="avatar"
          :title="$t('AVATAR') || '头像'"
          width="180">
          <template slot-scope="text,record">
            <a-avatar :src="record.avatar"/>
          </template>
        </a-table-column>
        <a-table-column
          data-index="gender"
          :title="$t('GENDER') || '性别'"
          width="180">
          <template slot-scope="text,record">
            {{ $dict('WECHAT_GENDER', record.gender) }}
          </template>
        </a-table-column>
        <a-table-column
          data-index="telephone"
          :title="$t('TELEPHONE') || '手机'"
          width="180">
          <template slot-scope="text,record">
            {{record.telephone ? record.telephone : '-'}}
          </template>
        </a-table-column>
        <a-table-column
          data-index="createAt"
          :title="$t('CREATE_AT') || '注册时间'"
          width="180">
          <template slot-scope="text,record">
            <time-formatter :time="record.createAt" format="YYYY-MM-DD"/>
          </template>
        </a-table-column>
        <a-table-column
          data-index="grade"
          :title=" $t('GRADE') || '会员等级'"
          width="180"
          style="text-align: center;">
          <template slot-scope="text,record">
            {{ $dict('USER_GRADE', record.grade) }}
          </template>
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION') || '操作'">
          <template slot-scope="text, record">
            <a-button type="link" @click="viewUser(record.id)">详细
            </a-button>
            <a-button type="link" @click="changeUserGrade(record.id)" v-if="record.grade != 'VIP'">转为VIP
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
:footer="null"
             title="提示"
             v-model="form.visible">
      <user-edit
        v-if="form.visible"
        :user-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </user-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryUsers,
  _deleteUser,
  _exportUserExcel,
  _updateUserGrade,
} from '@/api/userApi';
import DictSelect from '@/components/DictSelect.vue';
import TimeFormatter from '@/components/TimeFormatter.vue';
import UserEdit from './UserEdit.vue';

function searchUser() {
  this.table.pagination.page = 1;
  this.getUserList();
}

async function getUserList() {
  this.table.loading = true;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryUsers({
    nickname: this.searchForm.data.nickname,
    grade: this.searchForm.data.grade,
    telephone: this.searchForm.data.telephone,
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.pagination.total = result.totalElements;
  this.table.loading = false;
}

function addUser() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editUser(userId) {
  this.form.data.id = userId;
  this.form.visible = true;
}

function viewUser(userId) {
  this.$router.push(`/users/${userId}`);
}

function changeUserGrade(userId) {
  console.log(userId);
  // 将用户转为vip
  this.$confirm({
    title: '是否将用户转为VIP？',
    content: '',
    onOk: async () => {
      await _updateUserGrade(userId);
      this.$message.success('转换成功');
      this.getUserList();
    },
  });
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getUserList();
}

async function deleteUser(userId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteUser(userId);
      this.$message.success('删除成功');
      this.getUserList();
    },
  });
}

function handleSizeChange(val) {
  this.table.query.size = val;
  this.getUserList();
}

function handlePageChange(val) {
  this.table.query.page = val;
  this.getUserList();
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  this.table.sort = {
    prop: sorter.field,
    order: sorter.order,
  };
  this.getUserList();
}

async function exportUser() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  this.loading = true;
  window.open(`${process.env.VUE_APP_BASE_URL}/shop-users-export?grade=${this.searchForm.data.grade}&telephone=${this.searchForm.data.telephone}&nickname=${this.searchForm.data.nickname}`);
}

export default {
  name: 'UserList',
  components: {
    TimeFormatter,
    DictSelect,
    UserEdit,
  },

  data() {
    return {
      searchForm: {
        data: {
          nickname: '',
          telephone: '',
          grade: '',
        },
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        sort: {
          prop: 'updateAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getUserList,
    deleteUser,
    editUser,
    addUser,
    closeForm,
    viewUser,
    changeUserGrade,
    handlePageChange,
    handleSizeChange,
    searchUser,
    handleTableChange,
    exportUser,
  },
  created() {
    this.getUserList();
  },
};
</script>

<style scoped>

</style>
